<!--
 * @Author:
 * @Description:国家选择
 * @Date: 2024-12-20 14:16:51
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-checkout-web/src/components/mobile/country.vue
-->
<template>
  <div class="top-country" v-if="form">
    <!-- {{ form.CARD.country }} -->
    <div class="country-selector-box">
      <el-select ref="countrySelectRef" @visible-change="$emit('clickCountryHandler')"
        @change="(value) => $emit('countryChangeHandler', value)" class="country-selector"
        :popper-append-to-body="false" v-model="form.CARD.country" autocomplete="false" :disabled="disabled">
        <template slot="prefix">
          {{ (countryList.find(item => item.code === form.CARD.country) || {}).label }}
        </template>
        <el-option v-for="(c, cindex) in countryList" :key="cindex" :value="c.code" :label="c.label"></el-option>
      </el-select>
    </div>

  </div>
</template>

<script>
import COUNTRY_OPTIONS from '@/utils/tools/country';
export default {
  name: 'CountrySelect',
  props: {
    form: {
      type: Object,
      default: () => {

      },
    },
    countryChangeHandler: {
      type: Function,
      default: () => { },
    },
    clickCountryHandler: {
      type: Function,
      default: () => { },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      COUNTRY_OPTIONS,
    };
  },
  created() {
    this.initCountryList();
  },
  mounted() {

  },
  methods: {
    initCountryList() {
      this.countryList = COUNTRY_OPTIONS.map(item => ({
        ...item,
        label: this.$t(`message.country.${item.code}`),
      })).sort((s1, s2) => {
        try {
          const l = (this.lang === 'zh-tw' || this.lang === 'zh-cn') ? 'zh' : this.lang;
          return s1.label.localeCompare(s2.label, l, { ignorePunctuation: true });
        } catch (err) {
          //
        }
        return 1;
      });
    },
    blur() {
      const countrySelectDom = this.$refs.countrySelectRef;
      if (countrySelectDom) {
        countrySelectDom.blur();
      }
    },
  },
  filters: {

  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
  watch: {

  },
  mixins: [

  ],
};
</script>

<style lang="scss">
.country-selector-box {
  .el-select {
    width: 100%;
    display: block;
    height: 44px;

    .el-input.is-focus {
      .el-input__inner {
        border-color: var(--brand-color) !important;
      }

      .el-input__suffix {
        border-color: var(--brand-color) !important;
      }

      &.el-input--prefix {
        .el-input__suffix {
          border-color: var(--brand-color);
        }
      }
    }

    .el-input__inner:focus {
      border-color: var(--brand-color) !important;
    }

  }

}

.el-select-dropdown__item.selected {
  color: var(--brand-color) !important;
}
</style>
